import { Space } from "antd";
import {
  CheckCircleOutlined,
  LoadingOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "./RecruitmentQuestionMembershipCard.scss";
import { useEffect, useState } from "react";
import httpclient from "../../../service/httpclient";

function Description() {
  return (
    <div className="recruitment-question-membership-card-description">
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          解锁所有提单
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          会员模拟考试
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          秋招新题速达
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          更多福利...
        </Space>
      </div>
    </div>
  );
}

function RecruitmentQuestionMembershipCard() {
  const [productMembership, setProductMembership] = useState(null);
  useEffect(() => {
    httpclient.getOneProductMembership(1).then((res) => {
      setProductMembership(res);
    }, []);
  }, []);

  return (
    <div className="recruitment-question-membership-card">
      <div className="recruitment-question-membership-card-title">
        <b style={{ fontSize: 18, flexShrink: 0 }}>题库Pro会员</b>
        {productMembership ? (
          <Space style={{ flexShrink: 0 }} align="baseline">
            <span>
              <b style={{ fontSize: 20 }}>
                ¥{productMembership.calculated_price / 100}
              </b>
            </span>
            <span>
              {productMembership.calculated_price !==
                productMembership.price && (
                <del>¥{productMembership.price / 100}</del>
              )}
              /年
            </span>
          </Space>
        ) : (
          <LoadingOutlined />
        )}
      </div>

      <Description />

      <div
        className="recruitment-question-membership-card-button"
        type="primary"
        onClick={() =>
          window.open(
            "/info/product_membership/1",
            "_blank",
            "noopener,noreferrer"
          )
        }
      >
        <b style={{ fontSize: 16 }}>
          <Space>
            前往了解
            <RightOutlined />
          </Space>
        </b>
      </div>
    </div>
  );
}

export default RecruitmentQuestionMembershipCard;
